var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"wysiwyg"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"wysiwyg__inner"},[(_vm.title)?_c('h2',{staticClass:"title-one",domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"body",domProps:{"innerHTML":_vm._s(_vm.wysiwyg)}}),_vm._v(" "),(_vm.parsedPrimaryCta)?_c('div',{staticClass:"cta_wrapper"},[(_vm.parsedPrimaryCta)?_c('primary-button',{attrs:{"label":_vm.parsedPrimaryCta.title,"link":_vm.parsedPrimaryCta}}):_vm._e()],1):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/RichText.vue